const l = (t) => typeof t == "string" && (t === "2xl" || t === "xl" || t === "lg" || t === "md" || t === "sm" || t === "xs" || t === "2xs" || t === "3xs"), x = (t) => l(t) ? t : "md";
export {
  x as fallbackSize,
  l as validateSize
};
